import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard/Dashboard";
import Roles from "./pages/Roles/AccessControlPage";
import Tasks from "./pages/Tasks/Tasks";
import TaskDetails from "./pages/Tasks/TaskDetails"
import MainLayout from "./components/loyout/MainLayout";
import AdminsPage from "./pages/Users/AdminsPage";
import TechniciansPage from "./pages/Users/TechniciansPage";
import CustomersPage from "./pages/Users/CustomersPage";
import SetPassword from "./pages/Auth/SetPassword";
import SettingsPage from "./pages/Settings/SettingsPage"
import BrandModelSettings from "./pages/Settings/BrandModelSettings"
import RequirePermission from "./components/guards/RequirePermission";
import Unauthorized from "./pages/Unauthorized";
import TaskTemplatesPage from "./pages/TaskTemplates/TaskTemplatesPage";
import { LoaderProvider, useLoader } from "./store/loaderStore";
import { setLoaderStore } from "./api/loaderBridge";
import "./styles/layout.css";

function LoaderBridge() {
    const loader = useLoader();
    setLoaderStore(loader);
    return null;
}

function GlobalLoader() {
    const { loading } = useLoader();

    if (!loading) return null;

    return (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-white/60 backdrop-blur-sm">
            <div className="w-12 h-12 rounded-full border-4 border-primary border-t-transparent animate-spin" />
        </div>
    );
}

function App() {
  const user = localStorage.getItem("user"); // temporary auth simulation

  return (
    <LoaderProvider>
      <LoaderBridge />
            <GlobalLoader />
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/set-password" element={<SetPassword />} />

        {/* Protected Routes */}
        <Route
          path="/*"
          element={
            user
              ? <MainLayout />
              : <Navigate to="/login" replace />
          }
        >
          <Route path="dashboard" element={
            <RequirePermission permission="DASHBOARD_VIEW">
              <Dashboard />
            </RequirePermission>
            } />
          <Route path="users/admins" element={<AdminsPage />} />
          <Route path="users/technicians" element={<TechniciansPage />} />
          <Route path="users/customers" element={<CustomersPage />} />
          <Route path="roles" element={<Roles />} />
          <Route path="tasks" element={<Tasks />} />
          <Route path="tasks/:id" element={<TaskDetails />} />
          <Route path="unauthorized" element={<Unauthorized/>}/>
          <Route path="settings" element={<SettingsPage />} />
          <Route path="settings/brands" element={<BrandModelSettings />} />
          <Route path="task-templates" element={<TaskTemplatesPage />} />
        </Route>

        {/* Default redirect */}
        <Route path="*" element={<Navigate to="/dashboard" />} />
      </Routes>
    </Router>
  </LoaderProvider>);
}

export default App;
